import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../../widgets/form/InputSelectUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'

const AccountMappingUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // keywords
  keywords, onKeywordsChange, keywordsError, setKeywordsError,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update keywords'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='keywords' label='Keywords' maxLength={100}
      value={keywords} onChange={onKeywordsChange}
      error={keywordsError} setError={setKeywordsError}
      autoFocus={true} help='Add comma-separate keywords'
    />
  </ModalFormUI>

export default AccountMappingUpdateModalUI
